import DriveUpHero from 'assets/images/psp/PSPHero/drive-up-hero.webp';
import ChartOne1 from 'assets/images/psp/DriveUpIcons/DriveUpSizeChartOne/iconOne.svg';
import ChartOne2 from 'assets/images/psp/DriveUpIcons/DriveUpSizeChartOne/iconTwo.svg';
import ChartOne3 from 'assets/images/psp/DriveUpIcons/DriveUpSizeChartOne/iconThree.svg';
import ChartOne4 from 'assets/images/psp/DriveUpIcons/DriveUpSizeChartOne/iconFour.svg';
import ChartOne5 from 'assets/images/psp/DriveUpIcons/DriveUpSizeChartOne/iconFive.svg';
import ChartOne6 from 'assets/images/psp/DriveUpIcons/DriveUpSizeChartOne/iconSix.svg';
import Featured1 from 'assets/images/psp/FeaturedContentImages/car-storage-guide.webp';
import Featured2 from 'assets/images/psp/FeaturedContentImages/motorcycle.webp';
import Featured3 from 'assets/images/psp/FeaturedContentImages/featured2.webp';
import Featured4 from 'assets/images/psp/CarStorage/car-related4.webp';
import { storageCategories } from 'pages/PSPPage/utils/getPSPLinks';

const reviews = [
	{
		title: 'Booking a storage building online…',
		stars: 5,
		text: "Booking a storage building online couldn't have been any easier.",
		customerName: 'Floyd Dixon',
		date: 'May 18, 2025',
		link: 'https://www.trustpilot.com/reviews/682a0361abc2d7327f29c41c',
	},
	{
		title: 'Made it so easy! ',
		stars: 5,
		text: 'It was phenomenal not to have to call around and check rates. I could simply look through their list of available units and their prices. In just a few clicks, I had reserved one and got a confirmation email from the storage facility. Super easy.',
		customerName: 'Chelsea B',
		date: 'May 18, 2025',
		link: 'https://www.trustpilot.com/reviews/6829f1bc8b720324a1e15c84',
	},
	{
		title: 'I had a fantastic experience with SelfStorage…',
		stars: 5,
		text: 'I had a fantastic experience with SelfStorage. From the start, the staff was welcoming, professional, and made the whole process smooth and stress-free. The facility itself was spotless, secure, and easy to access—which really stood out to me. If you need a clean, reliable, and well-managed storage option, SelfStorage is definitely the way to go. Highly recommended!',
		customerName: 'Daylon Coleman',
		date: 'May 18, 2025',
		link: 'https://www.trustpilot.com/reviews/6828c99fab7da691109e37ea',
	},
	{
		title: 'Concise and harmonious.',
		stars: 5,
		text: 'SelfStorage.com search feature streamlined finding the right unit(s). Immediate follow-up text upon reservation. The reservation process was simple and easy, and nothing was charged up front.',
		customerName: 'Corbin Robinson',
		date: 'May 16, 2025',
		link: 'https://www.trustpilot.com/reviews/68262fe9ce693ab3495bd8b7',
	},
];

const faqs = [
	{
		question:
			'What is drive up storage, and how is it different from regular storage?',
		answer: 'Drive up access storage unit facilities have ground-level units with exterior doors facing driveways or parking areas. Regular (interior) units are located inside buildings, requiring you to navigate hallways, elevators, or stairs—making drive up storage much more convenient for heavy or frequent loads.',
	},
	{
		question: 'Are drive up storage units climate controlled?',
		answer: 'Some are, but most storage units with drive up access are non-climate controlled since they have exterior-facing doors. If you need temperature control for sensitive items, ask about drive up [climate controlled units](https://www.selfstorage.com/blog/what-is-climate-controlled-storage-2/).',
	},
	{
		question: 'Can I fit my car in a drive up access storage unit?',
		answer: "Yes! A 10x20 or larger [drive up access storage unit can accommodate most cars, trucks, or SUVs](https://www.selfstorage.com/blog/how-to-store-a-car/). Make sure to verify door width (typically 8-10 feet) and ceiling height if you're storing a lifted truck or tall vehicle.",
	},
	{
		question: 'Is drive up storage more expensive than interior units?',
		answer: "Not usually. In fact, drive up storage is often slightly cheaper because it lacks climate control. You're paying for convenience and accessibility without the added cost of HVAC systems found in interior storage buildings.",
	},
	{
		question: 'Are drive up units secure?',
		answer: "Absolutely. Storage units with drive up access feature the same security as interior units: individual locks, gated entry, surveillance cameras, and often on-site management. The only difference is location—they're outside the building rather than inside.",
	},
	{
		question: 'What can I store in a drive up access storage unit?',
		answer: "Almost anything: furniture, boxes, vehicles, recreational equipment, business inventory, tools, seasonal decorations, and more. Since most drive up storage units aren't climate controlled, avoid storing items highly sensitive to temperature fluctuations like antiques, musical instruments, or electronics for long periods.",
	},
	{
		question: 'How wide should the driveway be for easy loading?',
		answer: 'Look for facilities with at least 12-15 feet of driveway clearance in front of your unit. This allows room for your vehicle, an open tailgate, and space to maneuver. The best storage units with drive up access have wide lanes or pull-through designs for easy navigation.',
	},
];

const whoBenefitsData = {
	title: 'Drive Up Storage Unit Sizes & Pricing',
	description:
		'Drive up storage offers convenience that you’d think would come at a premium—but drive up access storage units and other storage amenities are incredibly affordable if you shop smart (with **SelfStorage.com**)! \n\nWe’ve compiled recent pricing data from our network to bring you the average monthly cost of storage units with drive up access.',
	contentdec:
		'Pricing data sourced from **SelfStorage.com** market rates. Drive up access storage unit costs are generally comparable to or slightly lower than climate controlled interior units. Actual prices vary by location and season.',
	storageData: [
		{
			size: '5x10',
			heading: "5' wide x 10' long",
			desc: [
				'**Best For**: Small loads, boxes, seasonal items, motorcycle \n\n **Average Monthly Cost***: $75 - $115',
			],
		},
		{
			size: '10x10',
			heading: "10' wide x 10' long",
			desc: [
				'**Best For**: 1-bedroom apartment, appliances, small vehicle \n\n **Average Monthly Cost***: $95 - $170',
			],
		},
		{
			size: '10x15',
			heading: "10' wide x 15' long",
			desc: [
				'**Best For**: 2-bedroom home, large furniture, ATV or jet ski \n\n **Average Monthly Cost***: $130 - $220',
			],
		},
		{
			size: '10x20',
			heading: "10' wide x 20' long",
			desc: [
				'**Best For**: 3-bedroom home, car, boat, contractor equipment \n\n **Average Monthly Cost***: $165 - $275',
			],
		},
		{
			size: '10x30',
			heading: "10' wide x 30' long",
			desc: [
				'**Best For**: 4-bedroom home, multiple vehicles, large inventory \n\n **Average Monthly Cost***: $230 - $360',
			],
		},
		{
			size: '12x30',
			heading: "12' wide x 30' long",
			desc: [
				'**Best For**: Full garage contents, RV, commercial equipment \n\n **Average Monthly Cost***: $280 - $425',
			],
		},
	],
};

export const DriveUpContent = {
	type: 'Drive Up',
	reviews: reviews,
	sections: [
		{
			title: 'Drive-Up Storage Hero',
			background: 'default',
			modules: [
				{
					type: 'hero',
					id: 'drive-up-storage-hero',
					props: {
						content: {
							title: 'Find Affordable Drive-Up Self Storage',
							image: DriveUpHero,
							description:
								'Forget hauling boxes down long hallways or cramming into elevators. Storage units with drive up access let you park directly in front of your unit and load or unload from your vehicle in minutes—no carts, no stairs, no hassle. \n\n You’re juggling work, household chores, kids—there’s no need to add one more struggle to your plate. Drive up, unload (or load up), and get back on the road. Simple as that.\n\nFind storage convenience at the best price with **SelfStorage.com**.',
							CTAtext: 'Find Drive Up Self Storage',
							storageType: 'Drive-Up',
						},
					},
				},
			],
		},
		{
			title: 'Size Chart',
			modules: [
				{
					type: 'cardStrip',
					props: {
						heading: 'Why People Choose Drive Up Access Storage',
						content: '',
						cardData: [
							{
								title: 'Moving & Transitions',
								content:
									"When you're moving your entire household, drive up access storage unit convenience can't be beat. Back up your U-Haul or pickup truck, unload directly into your unit, and you're done. That’s one less thing on your to-do list, and the best way to [best moving anxiety](https://www.selfstorage.com/blog/moving-anxiety/).",
								imageSrc: ChartOne1,
								contentAlign: 'text-left',
							},
							{
								title: 'Heavy or Bulky Items',
								content:
									'Furniture, appliances, [motorcycles](https://www.selfstorage.com/blog/small-vehicle-storage-guide/), kayaks—large items are nearly impossible to maneuver down hallways or into elevators. Drive up storage lets you roll, slide, or wheel items straight from your vehicle to your unit.',
								imageSrc: ChartOne2,
								contentAlign: 'text-left',
							},
							{
								title: 'Frequent Access Needs',
								content:
									'Business owners who regularly rotate inventory or homeowners who swap out seasonal items benefit from the quick in-and-out nature of storage units with drive up access.',
								imageSrc: ChartOne3,
								contentAlign: 'text-left',
							},
							{
								title: 'DIY & Home Renovation Projects',
								content:
									"Contractors and [DIYers love the ease of loading and unloading tools](https://www.selfstorage.com/blog/category/diy-move/), materials, and equipment. When you're in the middle of a project, drive up access storage unit layouts mean you're not wasting time on logistics.",
								imageSrc: ChartOne4,
								contentAlign: 'text-left',
							},
							{
								title: 'Vehicle & Recreational Equipment Storage',
								content:
									'Motorcycles, ATVs, jet skis, and riding mowers drive or roll right into your unit. No ramps needed for elevated units or indoor facilities—just drive up, drive in, secure the door.',
								imageSrc: ChartOne5,
								contentAlign: 'text-left',
							},
							{
								title: 'Elderly & Mobility-Challenged Renters',
								content:
									'For those with physical limitations, what is drive up storage if not a practical solution? Eliminating stairs, heavy doors, and long distances makes storage accessible for everyone.',
								imageSrc: ChartOne6,
								contentAlign: 'text-left',
							},
						],
					},
				},
			],
		},
		{
			title: 'Drive Up Storage Unit Sizes & Pricing',
			modules: [
				{
					type: 'sizeComparisonSection',
					props: {
						content: {
							title: whoBenefitsData.title,
							description: whoBenefitsData.description,
							image: whoBenefitsData.image,
							contentdec: whoBenefitsData.contentdec,
						},
						storageData: whoBenefitsData.storageData,
					},
				},
			],
		},
		{
			title: 'Reviews Section',
			modules: [
				{
					type: 'reviews',
					props: {
						reviewsData: {
							reviews,
							headerTitle: 'Drive Up Self Storage: ',
						},
					},
				},
			],
		},
		{
			title: 'Faqs Section',
			modules: [
				{
					type: 'faqs',
					props: {
						content: {
							header: 'Drive Up Self Storage FAQs',
							faqs,
						},
					},
				},
			],
		},
		{
			title: 'featured content',
			background: 'darkBlue',
			modules: [
				{
					type: 'featuredContent',
					props: {
						data: {
							heading: 'Learn All About Drive Up Self Storage',
							data: {
								slug: '',
								unitCards: [
									{
										title: 'Storage Tips',
										url: 'https://www.selfstorage.com/blog/car-storage-size-guide/',
										date: 'March 3, 2025',
										image: Featured1,
										content:
											'Choosing the Right Storage Unit for Your Vehicle',
									},
									{
										title: 'Storage Tips',
										url: 'https://www.selfstorage.com/blog/small-vehicle-storage-guide/',
										date: 'October 16, 2025',
										image: Featured2,
										content:
											'Small Vehicle Storage: How to Store Motorcycles, ATVs, and Golf Carts',
									},
									{
										title: 'Storage Tips',
										url: 'https://www.selfstorage.com/blog/how-to-store-a-boat-2',
										date: 'July 23, 2025',
										image: Featured3,
										content:
											'Best Way to Store a Boat During Off-Season',
									},
									{
										title: 'Storage Tips',
										url: 'https://www.selfstorage.com/blog/long-term-rv-storage-tips-2/',
										date: 'September 9, 2025',
										image: Featured4,
										content:
											'RV Storage: Long-Term Storage Types & Tips to Prepare',
									},
								],
							},
						},
					},
				},
			],
		},
		{
			title: 'Link to other PSPs',
			background: 'lighterBlue',
			modules: [
				{
					type: 'links',
					props: {
						heading: {
							headingName: 'More ways to store',
						},
						linksList: storageCategories.driveUpAccess,
					},
				},
			],
		},
		{
			title: 'nearby units',
			modules: [
				{
					type: 'storageNearYou',
					props: {
						type: 'Drive Up',
					},
				},
			],
		},
	],
	storageType: 'Drive-Up',
};
